import React, { useEffect, type ReactNode } from 'react';
import type { Action } from 'react-sweet-state';
import { createStore, createStateHook, createActionsHook } from 'react-sweet-state';

type State = {
	active: boolean;
};

const initialState = {
	active: false,
};

const actions = {
	setActive:
		(active: boolean): Action<State> =>
		({ setState }) => {
			setState({ active });
		},
};

const EnhanceSpotlightTourStore = createStore({
	initialState,
	actions,
});

export const useEnhanceSpotlightTourActive = createStateHook(EnhanceSpotlightTourStore, {
	selector: (state) => state.active,
});

const useActions = createActionsHook(EnhanceSpotlightTourStore);

const WithEnhanceSpotlightTourActiveComponent = ({
	children,
	setActive,
}: {
	children: ReactNode;
	setActive: (active: boolean) => void | Promise<void>;
}) => {
	useEffect(() => {
		void setActive(true);
		return () => {
			void setActive(false);
		};
	}, [setActive]);

	return children;
};

export const WithEnhanceSpotlightTourActive = ({ children }: { children: ReactNode }) => {
	const { setActive } = useActions();
	return (
		<WithEnhanceSpotlightTourActiveComponent setActive={setActive}>
			{children}
		</WithEnhanceSpotlightTourActiveComponent>
	);
};
